<template>
  <div class="container">
    <nav class="add-navigation">
      <div @click="$emit('close')" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Company accounts</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$emit('close')" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addUser">Add User</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add User</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-input
            type="text"
            name="first name"
            v-model="contact.first_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter first name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('first name')"
          >{{ errors.first('first name') }}</div>
          <primary-input
            type="text"
            name="user name"
            v-model="contact.user_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('user name')}"
            placeholder="Enter username"
          />
          <div class="help is-danger" v-if="errors.has('user name')">{{ errors.first('user name') }}</div>
          <primary-select
            type="text"
            name="status"
            class="type"
            v-model="contact.is_active"
            :class="{'input': true, 'is-danger': errors.has('status')}"
            placeholder="Status"
            :options="statusTypes"
          />
          <div class="help is-danger" v-if="errors.has('status')">{{ errors.first('status') }}</div>
          <primary-select
            v-if="contact.is_active === 'true' || contact.is_active === true"
            type="text"
            name="product"
            class="type"
            v-model="contact.products"
            :class="{'input': true, 'is-danger': errors.has('product')}"
            placeholder="Products"
            :options="products"
          ></primary-select>
          <div class="help is-danger" v-if="errors.has('product')">{{ errors.first('product') }}</div>
        </div>
        <div class="col">
          <primary-input
            type="text"
            name="last name"
            v-model="contact.last_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('last name')}"
            placeholder="Enter last name"
          />
          <div class="help is-danger" v-if="errors.has('last name')">{{ errors.first('last name') }}</div>
          <primary-input
            type="password"
            name="password"
            v-model="contact.passwd"
            v-validate="'required'"
            ref="password"
            :class="{'input': true, 'is-danger': errors.has('password')}"
            placeholder="********"
          />
          <div v-if="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</div>
          <primary-input
            type="text"
            name="ip"
            class="field"
            v-model="contact.allowed_ip_list"
            v-validate="{
                  regex: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/   
                }"
            :class="{'input': true, 'is-danger': errors.has('ip')}"
            placeholder="Enter IP"
          />
          <div class="help is-danger" v-if="errors.has('ip')">{{ errors.first('ip') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
  },
  props: ["companyId"],
  data: () => ({
    statusTypes: [
      { name: "Active", value: true },
      { name: "InActive", value: false },
    ],
    contact: {},
  }),
  computed: {
    ...mapGetters({
      getProducts: "products/getProducts",
      totalItems: "products/getTotal",
    }),
    products() {
      return this.getProducts.map((item) => {
        return { name: item.product_name, value: item.product_uuid };
      });
    },
  },
  created() {
    this.getProductList();
  },
  methods: {
    ...mapActions({
      viewAllProducts: "products/getProductList",
    }),
    getProductList: async function () {
      await this.viewAllProducts({ company_uuid: this.companyId });
      await this.viewAllProducts({
        perPage: this.totalItems,
        company_uuid: this.companyId,
      });
    },
    addUser: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }
      try {
        if (
          (this.contact.is_active === "true" ||
            this.contact.is_active === true) &&
          this.contact.products
        ) {
          this.contact.products = [...this.contact.products];
        } else {
          this.contact.products = [];
        }
        this.contact.company_uuid = this.companyId;
        await this.$store.dispatch("AddUser", {
          user: this.contact,
        });

        // this.$validator.fields.items.forEach( field => {
        //     field.reset();
        //     this.$validator.errors.remove(field.name, field.scope);
        // })

        this.$success("User have been added.");
        this.$emit("close");
      } catch (err) {
        this.$error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 115px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        margin-right: 5px;
        .input {
          margin-bottom: 20px;
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .dimension,
        #editdropzone {
          min-height: 90px;
          height: 90px;
          width: 90px;
          border-radius: 45px;
          .dz-preview,
          .dz-processing,
          .dz-image-preview,
          .dz-success,
          .dz-complete,
          .dz-complete {
            height: 80px;
            width: 80px;
            border-radius: 50px;
            margin-left: -40px;
            min-height: 80px;
            top: -20px;
          }
          .dz-image {
            padding: 5px;
            img {
              height: 80px;
              width: 80px;
              border-radius: 50px;
            }
          }
          .dz-details {
            height: 80px;
            width: 80px;
            border-radius: 50px;
            .dz-size {
              padding-top: 15px;
              span {
                font-size: 14px;
              }
            }
          }
          a {
            font-size: 10px;
            height: 80px;
            width: 80px;
            border-radius: 50px;
            margin-top: 20px;
            margin-left: 0px;
          }
        }
        .upload-contaioner {
          background-color: #ffffff;
          height: 265px;
          margin-right: 15px;
          display: flex;
          .photo {
            height: 90px;
            width: 90px;
            border: 1px solid #5171f3;
            border-style: dashed;
            border-radius: 45px;
            background-color: #ffffff;
            img {
              height: 80px;
              widows: 80px;
              border-radius: 50px;
              padding: 5px;
            }
          }
          .upload-content {
            display: flex;
            margin: 0 66px 0 15px;
            span {
              margin-top: 10px;
              height: 25px;
              width: 194px;
              color: #55616e;
              font-size: 16px;
              line-height: 20px;
            }
            input[type="file"] {
              position: absolute;
              height: 36px;
              width: 136px;
              opacity: 0;
              cursor: pointer;
              z-index: 1;
              margin-top: 30px;
            }
            // .upload-button {
            //     height: 36px;
            //     width: 136px;
            //     border-radius: 4px;
            //     background-color: #51A3F3;
            //     position: absolute;
            //     margin-top: 30px;
            // }
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

